export class ContractEdit {

	contractCodeFp2: number;
	vinKey: string;
	coverageKey: number;
	productKey: number;
	coverageCode: string;
	coverageCategory: string;
	productCode: string;
	contractStatusCode: number;
	cvvgDate: Date;
	coverageStartDate: Date;
	coverageEndDate: Date;
	coverageKm = 0;
	country: string;
	operation: string;
	vin: string;
	csId: string;
	contractRemarks: string;	
	coverageVisitCounter = 0;
	email: string;
	coverageStartVisit: number;
	cancelledTotalValue: number;

	constructor() {
	}
}